module.exports = __webpack_public_path__ + "img/image24.132a269a.png";